import React, { useState } from 'react';

const FOCUS_OPTIONS = [
    { value: '', label: "Today's Auto (based on day of week)" },
    { value: 'mattress', label: 'Mattress (High-Ticket)' },
    { value: 'wearable', label: 'Wearables & Tech' },
    { value: 'supplement', label: 'Supplements & Aids' },
    { value: 'app', label: 'Apps & Meditation' },
    { value: 'accessory', label: 'Accessories' },
];

const QuickGenerate = () => {
    const [focus, setFocus] = useState('');
    const [generating, setGenerating] = useState(false);
    const [result, setResult] = useState(null);
    const [error, setError] = useState(null);
    const [history, setHistory] = useState([]);

    const handleGenerate = async () => {
        setGenerating(true);
        setError(null);
        setResult(null);

        try {
            const url = focus
                ? `/.netlify/functions/trigger-daily-article?focus=${focus}`
                : '/.netlify/functions/trigger-daily-article';

            const response = await fetch(url);
            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.error || 'Generation failed');
            }

            setResult(data);
            setHistory(prev => [data, ...prev]);
        } catch (err) {
            console.error('Quick generate error:', err);
            setError(err.message);
        } finally {
            setGenerating(false);
        }
    };

    return (
        <div className="keywords-generator">
            <h2>Quick Generate</h2>
            <p style={{ color: 'rgba(255,255,255,0.6)', marginBottom: '1.5rem' }}>
                Trigger the daily article generation on demand. Picks the best unused keyword,
                fetches matching affiliate links, and auto-publishes a fully written article.
            </p>

            {error && (
                <div className="admin-status error">{error}</div>
            )}

            {result && (
                <div className="admin-status success">
                    Article published: <strong>{result.title}</strong>
                    {' '}— Keyword: "{result.keyword}" — Focus: {result.affiliateFocus}
                </div>
            )}

            <div className="ai-generation-panel">
                <h3>Generate Article Now</h3>
                <div className="ai-generation-options">
                    <div className="form-group">
                        <label>Affiliate Focus</label>
                        <select
                            value={focus}
                            onChange={(e) => setFocus(e.target.value)}
                            className="keywords-sort"
                        >
                            {FOCUS_OPTIONS.map(opt => (
                                <option key={opt.value} value={opt.value}>{opt.label}</option>
                            ))}
                        </select>
                    </div>
                </div>

                {generating ? (
                    <div className="generating-status">
                        <div className="spinner"></div>
                        Generating and publishing article... this takes 30-60 seconds
                    </div>
                ) : (
                    <button className="btn-primary" onClick={handleGenerate}>
                        Generate &amp; Publish Article
                    </button>
                )}
            </div>

            {history.length > 0 && (
                <div style={{ marginTop: '2rem' }}>
                    <h3 style={{ fontFamily: "'Playfair Display', serif", marginBottom: '1rem' }}>
                        Generated This Session
                    </h3>
                    <table className="admin-table">
                        <thead>
                            <tr>
                                <th>Title</th>
                                <th>Keyword</th>
                                <th>Focus</th>
                            </tr>
                        </thead>
                        <tbody>
                            {history.map((item, i) => (
                                <tr key={i}>
                                    <td>{item.title}</td>
                                    <td>{item.keyword}</td>
                                    <td><span className="badge badge-featured">{item.affiliateFocus}</span></td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default QuickGenerate;
